import { render } from "./markdown_content.vue?vue&type=template&id=31a52f92"
import script from "./markdown_content.vue?vue&type=script&lang=js"
export * from "./markdown_content.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/markdown_content.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31a52f92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31a52f92', __exports__)) {
    api.reload('31a52f92', __exports__)
  }
  
  module.hot.accept("./markdown_content.vue?vue&type=template&id=31a52f92", () => {
    api.rerender('31a52f92', render)
  })

}


export default __exports__